import Vue from 'vue';
import Vuex from 'vuex';

import projectsService from '../components/projects/projects.service'
import apartmentService from '../components/apartments/apartments.service'
import dataService from '../data/service'
import digitalResourcesService from '../components/digitalResources/digitalResources.service'
import childCareProgramsService from '../components/childCarePrograms/childCarePrograms.service'
import foodResourceService from '../components/foodResources/foodResources.service'
import parksAccessibilityService from '../components/parksAccessibility/parksAccessibility.service'

Vue.use(Vuex);

const state = {
  projects: [],
  projectsLoaded: false,
  dailyWorkLoaded: false,
  civicAssociations: [],
  voterPrecincts: [],
  civicInfo: [],
  apartments: [],
  digitalResources: [],
  childCarePrograms: [],
  foodResources: [],
  familyDayCarePrograms: [],
  parkAccessibilities: []
}

const store = new Vuex.Store({
  state,
  getters: {
    projects: (state) => {
      return state.projects
    },
    civicAssociations: (state) => {
      return state.civicAssociations
    },
    voterPrecincts: (state) => {
      return state.voterPrecincts
    },
    apartments: (state) => {
      return state.apartments
    },
    digitalResources: (state) => {
      return state.digitalResources
    },
    childCarePrograms: (state) => {
      return state.childCarePrograms
    },
    familyDayCarePrograms: (state) => {
      return state.familyDayCarePrograms
    },
    parkAccessibilities: (state) => {
      return state.parkAccessibilities
    },
    foodResources: (state) => {
      return state.foodResources
    }
  },
  actions: {
    loadProjects (context) {
      if (!this.state.projectsLoaded) {
        projectsService.loadProjects().then(projects => {
          context.commit('loadProjects', projects);
        });
      }
      if (!this.state.dailyWorkLoaded) {
        projectsService.loadDailyWork().then(dailyWork => {
          context.commit('loadDailyWork', dailyWork);
        });
      }
    },
    loadCivicAssociations (context) {
      if (state.civicAssociations.length === 0) {
        dataService.loadCivicAssociations().then(civicAssns => {
          context.commit('loadCivic', civicAssns)
        });
      }
    },
    loadVoterPrecincts (context) {
      if (state.voterPrecincts.length === 0) {
        dataService.loadVoterPrecincts().then(voter => {
          context.commit('loadVoterPrecincts', voter)
        });
      }
    },
    loadApartments (context) {
      if (state.apartments.length === 0) {
        apartmentService.loadApartments().then(apartments => {
          context.commit('loadApartments', apartments);
        })
      }
    },
    loadDigitalResources (context) {
      if (state.digitalResources.length === 0) {
        digitalResourcesService.loadDigitalResources().then(digitalResources => {
          context.commit('loadDigitalResources', digitalResources);
        })
      }
    },
    loadChildCarePrograms (context) {
      if (state.childCarePrograms.length === 0) {
        childCareProgramsService.loadChildCare().then(childCarePrograms => {
          context.commit('loadChildCarePrograms', childCarePrograms);
        })
      }
    },
    loadFamilyDayCarePrograms (context) {
      if (state.familyDayCarePrograms.length === 0) {
        childCareProgramsService.loadFamilyDayCare().then(familyDayCarePrograms => {
          context.commit('loadFamilyDayCarePrograms', familyDayCarePrograms);
        })
      }
    },
    loadParkAccessibilities (context) {
      if (state.parkAccessibilities.length === 0) {
        parksAccessibilityService.loadParkAccessibilities().then(parkAccessibilities => {
          context.commit('loadParkAccessibilities', parkAccessibilities);
        })
      }
    },
    loadFoodResources (context) {
      if (state.foodResources.length === 0) {
        foodResourceService.loadFoodResources().then(data => {
          context.commit('loadFoodResources', data);
        })
      }
    }
  },
  mutations: {
    loadProjects (state, projects) {
      state.projects = state.projects.concat(projects);
      state.projectsLoaded = true;
    },
    loadDailyWork (state, dailyWork) {
      state.projects = state.projects.concat(dailyWork);
      state.dailyWorkLoaded = true;
    },
    loadCivic (state, civicAssns) {
      state.civicAssociations = civicAssns;
    },
    loadVoterPrecincts (state, voter) {
      state.voterPrecincts = voter;
    },
    loadApartments (state, apartments) {
      state.apartments = apartments;
    },
    loadDigitalResources (state, digitalResources) {
      state.digitalResources = digitalResources;
    },
    loadChildCarePrograms (state, childCarePrograms) {
      state.childCarePrograms = childCarePrograms;
    },
    loadFamilyDayCarePrograms (state, familyDayCarePrograms) {
      state.familyDayCarePrograms = familyDayCarePrograms;
    },
    loadParkAccessibilities (state, parkAccessibilities) {
      state.parkAccessibilities = parkAccessibilities;
    },
    loadFoodResources (state, data) {
      state.foodResources = data;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js